import * as React from 'react';

import * as styles from './link.css';

interface ILink {
  href: string;
  target: '_blank' | '_self' | '_parent' | '_top';
  rel?: 'nofollow' | 'noreferrer' | 'prefetch';
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const Link = ({ href, children, target, rel, onClick }: ILink): React.JSX.Element => {
  return (
    <a className={styles['link']} onClick={onClick} href={href} target={target} rel={rel}>
      {children}
    </a>
  );
};
